<template>
<div class="c-resource-link" :data-sortindex="sortIndex">
    <template v-if="mode === 'view'">
        <div class="c-resource-link__link t-space-between">
            <a :href="link" target="_blank">{{text}}</a>
            <div>
                <div class="c-resource-link__sorting">
                    <can i="manage" :a="processType">
                        <form class="c-form" @submit.prevent="handleSubmit">
                            <button v-if="sortIndex !== sortIndexes[0]" class="c-button c-button--linkstyle c-button--reset c-process-step__move-up c-resource-link__move-up" title="Flytta upp" type="submit" @click="setSubmitType('moveUp')">
                                <vue-icon name="expand" size="c-icon--17px"></vue-icon>
                            </button>
                            <br/>
                            <br v-if="sortIndex === sortIndexes[sortIndexes.length-1]"/>
                            <button v-if="sortIndex !== sortIndexes[sortIndexes.length-1]" class="c-button c-button--linkstyle c-button--reset" title="Flytta ner" type="submit" @click="setSubmitType('moveDown')">
                                <vue-icon name="expand" size="c-icon--17px"></vue-icon>
                            </button>
                        </form>
                    </can>
			    </div>
            </div>
        </div>
        <can i="manage" :a="processType">
            <button class="c-button c-button--linkstyle c-button--reset c-resource-link__button" type="button" @click="goToEditMode">
				<vue-icon name="edit" size="c-icon--17px"></vue-icon>
			</button>
        </can>
    </template>
    <template v-if="mode == 'create' || mode == 'edit'">
        <div class="c-resource-link__container t-margin-top-s t-margin-bottom-s t-border-green" v-bind:class="{'t-background-white': mode == 'create' || mode == 'edit'}">
            <div class="t-margin-left-s t-margin-right-s">
                <form class="c-form" @submit.prevent="handleSubmit">
                    <fieldset>
                        <div class="o-grid">
                            <div class="o-grid__column" data-size="sm:12 md:6 lg:6">
                                <div class="c-form__item">
                                    <vue-input label="Namn på mall" input-id="text" :value="text" ref="text"></vue-input>
                                </div>
                            </div>
                            <div class="o-grid__column" data-size="sm:12 md:6 lg:6">
                                <div class="c-form__item">
                                    <vue-input label="Länk till mall" input-id="link" :value="link" ref="link"></vue-input>
                                </div>
                                <p class="c-resource-link-input__sub">Klistra in länken till där man hittar mallen</p>
                            </div>
                        </div>
                    </fieldset>
                    <template v-if="mode === 'create'">
                        <button class="c-button c-button--primary t-margin-bottom-s" type="submit" @click="setSubmitType('create')">Skapa länk</button>
                        <button class="c-button c-button--linkstyle c-button--reset" type="button" @click="cancelCreateResourceLink">Avbryt</button>
                    </template>
                    <template v-if="mode === 'edit'">
                        <div class="t-space-between">
                            <div class="t-margin-bottom-xs">
                                <button class="c-button c-button--primary t-margin-top-s t-margin-bottom-s" type="submit" @click="setSubmitType('edit')">Spara</button>
                                <button class="c-button c-button--linkstyle c-button--reset" type="button" @click="cancelEditResourceLink">Avbryt</button>
                            </div>
                            <button type="submit" class="c-button c-button--linkstyle c-button--linkstyle__secondary c-button--reset t-margin-bottom-xs" @click="toggleDeleteLinkModal">
								<vue-icon name="delete" size="c-icon--17px"></vue-icon>
								<span class="c-button__title">Ta bort länk</span>
							</button>
                            <modal :show="showDeleteLinkModal" @closeModal="toggleDeleteLinkModal">
                                <div class="c-modal__content t-background-white t-text-align-center">
                                    <h1 class="t-text-style-alpha t-margin-bottom-s">Länken "{{text}}" kommer att tas bort</h1>
                                        <form @submit.prevent="handleSubmit" class="c-form">
                                            <button class="c-button c-button--linkstyle c-button--reset t-margin-top-m" @click="toggleDeleteLinkModal">Avbryt</button>
                                            <button type="submit" class="c-button c-button--primary t-margin-top-m" @click="setSubmitType('delete')">Ta bort länk</button>
                                        </form>
                                </div>
                            </modal>
                        </div>
                    </template>
                </form>
            </div>
        </div>
    </template>
</div>
</template>

<script>
import {
    mapGetters
} from 'vuex';
import VueInput from '@/components/vue-components/vue-input/VueInput.vue';
import VueIcon from '@/components/vue-components/vue-icon/VueIcon.vue';
import Modal from '@/components/vue-components/modal/Modal.vue';
export default {
    name: 'ResourceLink',
    props: {
        processId: {
            type: String,
            default: ''
        },
        processType: {
            type: String,
            default: ''
        },
        resourceId: {
            type: String,
            default: ''
        },
        resourceLinkId: {
            type: String,
            default: ''
        },
        mode: {
            type: String,
            default: 'view'
        },
        id: {
            type: String,
            default: ''
        },
        text: {
            type: String,
            default: ''
        },
        link: {
            type: String,
            default: ''
        },
        sortIndex: {
            type: Number,
            default: 1
        },
        sortIndexes: {
			type: Array,
			default: []
		}
    },
    components: {
        VueInput,
        VueIcon,
        Modal
    },
    data() {
        return {
            id: '',
            submitType: '',
            showDeleteLinkModal: false,
        }
    },
    computed: {
        resourceLinks() {
            if (this.id !== '0') {
                return this.$store.getters['processes/resourceLinks'](this.resourceId);
            } else {
                return {};
            }
        }
    },
    methods: {
        setSubmitType(type) {
            this.submitType = type;
        },
        goToEditMode() {
            this.mode = 'edit';
        },
        goToViewMode() {
            this.mode = 'view';
        },
        createResourceLink() {
            let text = this.$refs.text.getValue();
            let link = this.$refs.link.getValue();
            this.$emit('createResourceLink', {
                processStepResourceId: this.resourceId,
                text: text,
                link: link
            });
            this.reset();
        },
        editResourceLink() {
            let text = this.$refs.text.getValue();
            let link = this.$refs.link.getValue();
            this.$emit('editResourceLink', {
                resourceLinkId: this.resourceLinkId,
                text: text,
                link: link
            });
            this.reset();
            this.goToViewMode();
        },
        cancelEditResourceLink() {
            this.goToViewMode();
        },
        cancelCreateResourceLink() {
            this.$emit('toggleShowCreate');
        },
        deleteResourceLink() {
            this.$emit('deleteResourceLink', this.resourceLinkId);
            this.reset();
            this.goToViewMode();
        },
        moveUp() {
			this.$emit('sortResourceLinks', {
				id: this.resourceLinkId,
				sortIndex: this.sortIndex - 1,
			});
		},
		moveDown() {
			this.$emit('sortResourceLinks', {
				id: this.resourceLinkId,
				sortIndex: this.sortIndex + 1,
			});
		},
        handleSubmit() {
            switch (this.submitType) {
                case 'create':
                    this.createResourceLink();
                    break;
                case 'edit':
                    this.editResourceLink();
                    break;
                case 'delete':
                    this.deleteResourceLink();
                    break;
                case 'moveUp':
					this.moveUp();
					break;
				case 'moveDown':
					this.moveDown();
					break;
            }
        },
        toggleDeleteLinkModal() {
            this.showDeleteLinkModal = !this.showDeleteLinkModal;
        },
        reset(){
            this.showDeleteLinkModal = false;
            this.submitType = '';
        }
    },
    created() {
        if (this.$props.resourceLinkId) {
            this.id = this.$props.resourceLinkId;
        }
    }
}
</script>
